import { IMongoWorkspace } from '../../interfaces/mongo-workspace.interface';

export interface IConfig extends IMongoWorkspace {
    smtp: {
        auth: {
            user: string;
            pass: string;
        },
        host: string,
        port: string,
        secure: boolean
    };
}
